var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.00001C15.5304 7.00001 16.0391 7.21073 16.4142 7.5858C16.7893 7.96087 17 8.46958 17 9.00001L15 7.00001ZM21 9.00001C21.0003 9.93719 20.781 10.8614 20.3598 11.6986C19.9386 12.5357 19.3271 13.2626 18.5744 13.8209C17.8216 14.3792 16.9486 14.7534 16.0252 14.9135C15.1018 15.0737 14.1538 15.0153 13.257 14.743L11 17H9V19H7V21H4C3.73478 21 3.48043 20.8947 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V17.414C3.00006 17.1488 3.10545 16.8945 3.293 16.707L9.257 10.743C9.00745 9.91803 8.93857 9.04896 9.05504 8.19496C9.17152 7.34096 9.47062 6.52208 9.93199 5.79406C10.3934 5.06604 11.0062 4.44596 11.7287 3.97603C12.4512 3.50611 13.2665 3.19736 14.1191 3.07082C14.9716 2.94427 15.8415 3.0029 16.6693 3.2427C17.4972 3.4825 18.2637 3.89785 18.9166 4.46048C19.5696 5.02311 20.0936 5.71981 20.4531 6.50315C20.8127 7.2865 20.9992 8.13811 21 9.00001V9.00001Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/token.8c8353dc.svg";
export { ForwardRef as ReactComponent };